import React, { useEffect, useState } from 'react'
import { glidifyMob } from '../../../../scripts/dom/glidify'

interface RVData  {
  handle: string;
  shopDomain: string;
  productData: {
    image: string,
    title: string
  }
}

interface RecentlyViewedProps {
  dataSet: {
    handle: string,
    image: string,
    title: string,
    limit: string,
    langStrings: string,
    shopDomain: string
  }
}

const getRecentlyViewedFromStorage = (shopDomain: string) => {
  const data = window.localStorage.getItem(`blubolt:recentlyViewed:${shopDomain}`);
  if (!data) {
    return {}
  }
  return JSON.parse(data)
}

//combine existing products in local storage with current PDP product. Remove older visited products.
const setRecentlyViewedInStorage = (limit: number) => ({ handle, productData, shopDomain }: RVData): void => {
  //Create an array that combines recently viewed products from local storage with the handle and product data from the current page. 
  const data = Object.entries({ ...{ [handle]: productData }, ...getRecentlyViewedFromStorage(shopDomain) })
    //Remove older products from the array so there is only the number of products that matches the limit (+ the current product)
    .slice(0, limit + 1)
    //Turn array into object of productObjects
    .reduce((d, [key, val]) => ({ ...d, ...{ [key]: val } }), {})
  window.localStorage.setItem(`blubolt:recentlyViewed:${shopDomain}`, JSON.stringify(data))
}

const RecentlyViewed: React.FunctionComponent<RecentlyViewedProps> = ({ dataSet } : RecentlyViewedProps) => {
  const {handle, image, title, limit, langStrings, shopDomain} = dataSet
  const [recentlyViewed, setRecentlyViewed] = useState({[handle]: {image, title}});
  const [rvLangStrings, setRvLangLangStrings] = useState({} as Record<string, string>)
  const setRecentlyViewedInStorageWithLimit = setRecentlyViewedInStorage(parseInt(limit))

  //remove the product that matches the PDP so it doesn't appear in the recently viewed as well
  const prods = Object.entries(recentlyViewed).filter(([prodHandle]) => prodHandle !== handle)

  useEffect(() => {
    let parsedLangsStrings = {}
    try {
      parsedLangsStrings = JSON.parse(langStrings)
    } catch (e) {
      console.info(e)
    }
    setRvLangLangStrings(parsedLangsStrings)
  }, [])
  
  const { heading } = rvLangStrings;

  useEffect(() => {
    if (handle && image && title) {
      setRecentlyViewedInStorageWithLimit({ handle, productData: { image, title }, shopDomain })
    }
    setRecentlyViewed(getRecentlyViewedFromStorage(shopDomain))

  }, [])

  useEffect(() => {
    if (prods.length > 1) {
      glidifyMob()
    }
  }, [])

  if (prods.length < 1) {
    return <></>
  }

  return (
    <div>
      <h2 className="heading-2">{heading}</h2>
      <div>
        <div className="glide" data-glide-mob data-id="recently-viewed" data-glider-config='{"perView":2.2}'>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides recently-viewed">
              { prods.map(([prodHandle, prodData]) => {
                return (
                  <li className="recently-viewed-prod glide__slide" key={prodHandle}>
                    <a href={`/products/${prodHandle}`}>
                      <div className="recently-viewed-prod-image">
                        <img src={ decodeURI(prodData.image) } data-lazy-load />
                      </div>
                      <h4 className="recently-viewed-prod-title">{prodData.title}</h4>
                    </a>
                  </li>
                )
              }) }
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
};

export default RecentlyViewed